import React from 'react';

import Header from 'components/Header/HeaderApp';
import Bottom from 'components/Bottom';
import ContentChamadoSent from './ContentChamadoSent';

const ChamadoSent = () => {
  return (
    <>
      <Header />
      <ContentChamadoSent />
      <Bottom />
    </>
  );
};

export default ChamadoSent;
